import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function PythonAICloudDeveloperPage() {
  return <AICloudDeveloperPage technology="python-ai-cloud" />;
}
